import React from "react";

const UploadLoader = ({ message = "Verifying file(s)..." }) => {
    return (
        <div
            className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
                background: 'rgba(255,255,255,0.7)',
                zIndex: 10,
                top: 0,
                left: 0,
                borderRadius: 'inherit'
            }}
        >
            <div className="text-center">
                <div className="spinner-border text-primary" role="status"></div>
                <p className="mt-2" style={{ fontWeight: '500' }}>{message}</p>
            </div>
        </div>
    );
};

export default UploadLoader;
